/* eslint-disable no-unused-vars */
import './breadcrumbs.scss';
import { Tooltip } from 'bootstrap-italia';

export class Breadcrumbs {
  constructor() {
    this.containers = document.querySelectorAll('.breadcrumb-container');
    if (!this.containers.length) return;

    this.init();
    window.addEventListener('resize', this.debounce(() => this.init(), 200));
  }

  init() {
    this.containers.forEach((container) => {
      const breadcrumb = container.querySelector('.breadcrumb');
      const items = [...breadcrumb.querySelectorAll('.breadcrumb-item')];

      container.classList.remove('is-truncated');
      if (!container.closest('.section-intestazione.intestazione-img-dx')) return;
      if (items.length <= 2) return;

      items.forEach((item) => {
        item.style.removeProperty('--item-max-width');
        item.classList.remove('is-not-truncated');

        // Ripristina testo puro se era stato wrappato in .breadcrumb-text
        const textSpan = item.querySelector('.breadcrumb-text');
        if (textSpan) {
          item.replaceChildren(document.createTextNode(textSpan.textContent));
        }

        const targetEl = item.querySelector('a') || item;
        targetEl.removeAttribute('data-tooltip-init');
      });

      const containerWidth = breadcrumb.clientWidth;
      const separatorWidth = this.getSeparatorWidth(breadcrumb);

      const firstItem = items[0];
      const lastItem = items[items.length - 1];
      const middleItems = items.slice(1, -1);

      const firstWidth = firstItem.scrollWidth;
      const lastWidth = lastItem.scrollWidth;

      const separatorsTotal = separatorWidth * (items.length - 1);

      let availableSpace = containerWidth
        - firstWidth
        - lastWidth
        - separatorsTotal;

      if (availableSpace < 0) {
        availableSpace = 0;
      }

      container.classList.add('is-truncated');

      firstItem.classList.add('is-not-truncated');
      lastItem.classList.add('is-not-truncated');

      const MIN_ITEM_WIDTH = 50;

      const widthPerItem = middleItems.length > 0
        ? availableSpace / middleItems.length
        : 0;

      middleItems.forEach((item) => {
        const anchor = item.querySelector('a');
        const targetEl = anchor || item;

        const width = Math.max(MIN_ITEM_WIDTH, widthPerItem);
        item.style.setProperty('--item-max-width', `${width}px`);

        // misura corretta per item senza anchor
        const realWidth = anchor
          ? this.getNaturalWidth(anchor)
          : this.getTextWidth(item.textContent);

        if (realWidth <= width) {
          item.classList.add('is-not-truncated');
        } else if (anchor) {
          this.addTooltip(anchor);
        } else {
          // Item senza anchor che necessita troncamento: wrappa il testo in uno span
          // con min-width:0 così il testo può restringersi e il ::after resta visibile
          const text = item.textContent.trim();
          const span = document.createElement('span');
          span.className = 'breadcrumb-text';
          span.textContent = text;
          item.replaceChildren(span);
        }
      });
    });
  }

  // nuovo metodo per misurare testo puro (senza effetti del <li>)
  getTextWidth(text) {
    const span = document.createElement('span');
    span.style.visibility = 'hidden';
    span.style.position = 'absolute';
    span.style.whiteSpace = 'nowrap';
    span.style.font = 'inherit';
    span.textContent = text.trim();

    document.body.appendChild(span);
    const { width } = span.getBoundingClientRect();
    document.body.removeChild(span);

    return width;
  }

  getSeparatorWidth(breadcrumb) {
    const probe = document.createElement('span');

    probe.textContent = '>';
    probe.style.visibility = 'hidden';
    probe.style.whiteSpace = 'nowrap';
    probe.style.marginLeft = '10px';

    breadcrumb.appendChild(probe);
    const { width } = probe.getBoundingClientRect();
    breadcrumb.removeChild(probe);

    return width;
  }

  getNaturalWidth(targetEl) {
    const el = targetEl;

    const prev = {
      maxWidth: el.style.maxWidth,
      overflow: el.style.overflow,
      textOverflow: el.style.textOverflow,
      whiteSpace: el.style.whiteSpace,
    };

    el.style.maxWidth = 'none';
    el.style.overflow = 'visible';
    el.style.textOverflow = 'clip';
    el.style.whiteSpace = 'nowrap';

    const width = el.scrollWidth;

    el.style.maxWidth = prev.maxWidth;
    el.style.overflow = prev.overflow;
    el.style.textOverflow = prev.textOverflow;
    el.style.whiteSpace = prev.whiteSpace;

    return width;
  }

  addTooltip(targetEl) {
    if (targetEl.getAttribute('data-tooltip-init')) return;

    targetEl.setAttribute('data-tooltip-init', 'true');

    const tooltip = new Tooltip(targetEl, {
      trigger: 'manual',
      placement: 'top',
      title: targetEl.textContent.trim(),
    });

    let timeout;

    targetEl.addEventListener('mouseenter', () => {
      tooltip.show();
      timeout = setTimeout(() => tooltip.hide(), 4000);
    });

    targetEl.addEventListener('mouseleave', () => {
      clearTimeout(timeout);
      tooltip.hide();
    });
  }

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }
}
